<div class="expired-change-email-link" [mmTestId]="'BUSINESS_INFO.EXPIRED_CHANGE_EMAIL_LINK_DIALOG'">
  <mm-dialog-title>
    {{ 'PAGES.ACCOUNT.INFO.EXPIRED_CHANGE_EMAIL_LINK_DIALOG.TITLE' | translate: { linkLifetime: linkLifetime } }}
  </mm-dialog-title>

  <mm-dialog-content>
    {{ 'PAGES.ACCOUNT.INFO.EXPIRED_CHANGE_EMAIL_LINK_DIALOG.TEXT' | translate: { linkLifetime: linkLifetime } }}
  </mm-dialog-content>

  <mm-dialog-footer>
    <button mm-button
            class="expired-change-email-link__keep-button"
            color="ghost"
            mmDialogClose
            [mmTestTarget]="'keep-email-button'">
      {{ 'PAGES.ACCOUNT.INFO.EXPIRED_CHANGE_EMAIL_LINK_DIALOG.KEEP_EMAIL' | translate }}
    </button>
    <button mm-button
            class="expired-change-email-link__change-button"
            [mmDialogClose]="true"
            [mmTestTarget]="'change-email-button'">
      {{ 'PAGES.ACCOUNT.INFO.EXPIRED_CHANGE_EMAIL_LINK_DIALOG.CHANGE_EMAIL' | translate }}
    </button>
  </mm-dialog-footer>
</div>
